const config = {
    google: {
        API_KEY: "", CLIENT_ID: "", SECRET: "",
    }, facebook: {
        APP_ID: "",
    },
    api: {
        SERVER_URL: window.location.origin,
        HOME_URL: window.location.origin + "/",
        // API_URL: "http://localhost:4000/",
        API_URL: window.location.origin + "/"
        // HOME_URL: "http://localhost:8000",
    }
};

export const { google, facebook, api } = config;
export default config;